import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutCards } from "@/mocks/home";

const aboutHighlights = [
  "Own covered-body fleet & trained crews",
  "House, office and commercial shifting",
  "Own warehouse for safe storage",
  "Transparent, item-wise pricing",
];

export default function AboutSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="aspect-[4/3] w-full overflow-hidden rounded-lg border border-background-200">
            <img
              src="/uploads/truck-on-road.jpeg"
              alt="Lahari Packers and Movers branded covered-body truck ready for a move in Bangalore"
              title="Lahari Packers and Movers Bangalore fleet"
              className="h-full w-full object-cover object-center"
            />
          </div>
          <div>
            <SectionHeading
              align="left"
              eyebrow="About Us"
              title="About Lahari Packers and Movers Bangalore – 100% Safe and Trusted Relocation Services"
              subtitle="Lahari Packers and Movers Bangalore offers Safe Domestic Moves, Office Relocation services, Corporate Moves and Packaging Services 24×7."
            />
            <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {aboutHighlights.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-primary-500" aria-hidden="true" />
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-7">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
              >
                More About Us <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2 lg:grid-cols-3">
          {aboutCards.map((card) => (
            <Link
              key={card.title}
              to={card.href}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {card.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{card.description}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                  Read more <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}